// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { GitBranch } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconGitBranch(props: any) {
    return <IconBase icon={GitBranch} {...props} />
  }

  export default IconGitBranch
  